module.exports = ":host { width: 100%;}\r\n\r\n.center{\r\n  width: 50%;\r\n  margin:10px  auto;\r\n}\r\n\r\n\r\n"